module.exports = __webpack_public_path__ + "static/img/fufuture-1.10f08a4d.svg";